export type DealCommissionPayload = {
  commission_amount: number;
  commission_member_id: string | null;
  commission_name: string | null;
};

export function parseCommissionAmount(raw: string): number {
  const amount = Number.parseFloat(raw.replace(",", "."));
  if (!Number.isFinite(amount) || amount < 0) return 0;
  return amount;
}

export function buildDealCommission(params: {
  amountRaw: string;
  memberId: string;
  memberLabel: string;
  freeName: string;
}): DealCommissionPayload {
  const commission_amount = parseCommissionAmount(params.amountRaw);
  if (params.memberId) {
    return {
      commission_amount,
      commission_member_id: params.memberId,
      commission_name: params.memberLabel.trim() || null,
    };
  }
  const name = params.freeName.trim();
  return {
    commission_amount,
    commission_member_id: null,
    commission_name: name || null,
  };
}
